import * as actions from 'actions';

const INITIAL_STATE = [];

export default (state = INITIAL_STATE, action) => {
  switch(action.type) {
    case actions.FEED_RECEIVED: {
      const feedItemsNormalized = action.result.feedItems.map(feedItem => {
        const { chat, interests, journal, article, goals, questionnaire } = feedItem;
        if (chat) return ({chatId: chat.id});
        if (interests) return ({interestsId: interests.id});
        if (journal) return ({journalId: journal.id});
        if (article) return ({articleId: article.id});
        if (goals) return ({goalsId: goals.id});
        if (questionnaire) return ({questionnaireId: questionnaire.id});
      });

      if (action.page === 1) {
        return feedItemsNormalized;
      }

      return [
        ...state,
        ...feedItemsNormalized
      ];
    }

    // remove the journal entry form item after an entry has been successfully created
    case actions.JOURNAL_ENTRY_CREATE_SUCCESS: {
      return state.filter(feedItem => feedItem.journalId === undefined);
    }

    // remove the feed questionnaire after an it has been successfully sent
    case actions.FEED_QUESTIONNAIRE_SUBMIT_SUCCESS: {
      return state.filter(feedItem => feedItem.questionnaireId === undefined);
    }


    default:
      return state;
  }
};



/** WEBPACK FOOTER **
 ** ./src/members/state/feed/list/reducer.js
 **/